
import {register} from './../exports/theme-sections';
import slickSlider from './../features/slick-slider';

register('slider-content', [slickSlider]);
